export default __webpack_public_path__ + "static/media/ig-gradient-plan-pack-mid-market.e3e71ace.webp";